(function () {

    'use strict';

    angular
        .module('app.search')
        .controller('SearchCriteriaController', [
            'APP_CONFIG',
            '$q',
            '$scope',
            '$routeParams',
            '$location',
            'SearchService',
            'ConditionManagerService',
            'ConfigService',
            'OpenlaneService',
            'ApiService',
            'uuid',
            'LoggerApi',
            SearchCriteriaController
        ]);

        function SearchCriteriaController(APP_CONFIG, $q, $scope, $routeParams, $location, searchService, conditionManagerService, configService, openlaneService, apiService, uuid, loggerApiService){
            var vm = this;
            var _uuid = uuid.v4();
            var specificLocationSelected = [];
            var locationCriteria = [];
            var index = 0;
            var config = configService.scConfig();

            var checkboxConditions = config.checkboxConditions;
            config.otherOptions.forEach(function (opt) {
                checkboxConditions.push(opt.cond)
            });

            var conditionManager = conditionManagerService.createConditionManager(checkboxConditions);

            var criteria = {};
            vm.criteria = criteria;
            $scope.message = conditionManager.message;
            vm.checkboxGroupMessage = conditionManager.checkboxGroupMessage;
            vm.model = {"page": "criteria"};

            vm.model.otherOptions = config.otherOptions;

            //search results
            searchService.winnowingValues().then(function(response){
                var response = response.data;
                vm.years = response.years;
                vm.endYearRange = vm.years[0].id;
                vm.startYearRange = vm.years[vm.years.length - 1].id;
                vm.pageSizes = response.pageSizes;
                if ( $routeParams.langCode == 'en') {
                    $scope.gradeSizes = response.gradeSizesEn;
                }
                if ( $routeParams.langCode == 'fr') {
                    $scope.gradeSizes = response.gradeSizesFr;
                }
                vm.odometerList = response.odometer;
            }, function(err){
                console.log('err', err);
            });

            // history, back button
            $scope.$watch(function () {
                return $location.search();
            }, function (value, oldVal) {
                if (value != oldVal) {
                    conditionManager.updateModel(value);
                }
            });

            vm.selectAll = function (cond) {
                conditionManager.selectAll(cond, criteria);
            };
            vm.selectSome = function (cond) {
                conditionManager.selectSome(cond);
            };


            init();

            function init() {

                if (angular.isDefined($routeParams.locCode) && angular.isDefined($routeParams.langCode)) {
                    // normally the location watcher executes before the call to search, however that order is reversed for the back button
                    // so we need to make sure the model is initialized
                    $q.all([openlaneService.initSearchContext(),
                        apiService.getLocations($routeParams.langCode).then(function (response) {
                            if ($routeParams.locCode === APP_CONFIG.DEFAULT_HOME) {
                                var loc;
                                for (var i = 0; i < response.data.length; i++) {
                                    loc = response.data[i];

                                    if (loc.locationCode !== APP_CONFIG.DEFAULT_HOME) {
                                        specificLocationSelected.push(loc.locationId);
                                        locationCriteria.push({id:loc.locationId,name:loc.locationName});
                                    }
                                }
                            } else {
                                specificLocationSelected.push(apiService.getLocationByCode(response.data, $routeParams.locCode).locationId);
                                locationCriteria.push({
                                    id : apiService.getLocationByCode(response.data, $routeParams.locCode).locationId,
                                    name : apiService.getLocationByCode(response.data, $routeParams.locCode).locationName
                                });
                            }

                            vm.locationZeroCount = apiService.getLocationByCode(response.data, $routeParams.locCode).locationName;

                            loggerApiService.applicationEvent(3, "form1", "", "*","SearchCriteria","",_uuid);
                            loggerApiService.applicationEventAddEvent("location",$routeParams.locCode);
                            loggerApiService.applicationEventStart();
                            conditionManager.updateModel($location.search());
                            search();

                    })]);
                }


            }

            function search() {
                searchService.search($scope, function (searchContext) {
                    prepareForCountRetrieval(searchContext);
                    checkboxConditions.forEach(function (cn) {
                        config.getApplicableValuesConfig(cn).requestor(searchContext, conditionManager);
                    });

                })
                    .then(function (searchResult) {
                        var conditionValues = searchResult.getApplicableConditionValues();
                        // the transformer rely on the transformed values, so must execute in specific order.
                        // instead of enforcing the order in configuration, we just return a function instead of a value
                        // and execute it later. This model supports a simple one-level dependency between condition transformers.
                        var deferredTransformers = [];
                        /*Object.keys(conditionValues).forEach(function (key) {
                         var transformed = config.getApplicableValuesConfig(key).transformer(conditionValues, conditionManager, criteria);
                         if (typeof transformed === 'function') deferredTransformers.push({
                         "key": key,
                         "transformer": transformed
                         });
                         else criteria[key] = transformed;
                         });*/
                        Object.keys(conditionValues).forEach(function (key) {
                            var transformed = config.getApplicableValuesConfig(key).transformer(conditionValues, conditionManager, criteria);
                            if (typeof transformed === 'function') {
                                deferredTransformers.push({
                                    "key": key,
                                    "transformer": transformed
                                });
                            }else{
                                criteria[key] = transformed;

                                if(key == 'pao'){
                                    var rebuildArr = [];
                                    var count = 0;

                                    for(var i = 0;i <=locationCriteria.length-1;i++){
                                        index = criteria[key].map(function (item) {
                                            return item.id;
                                        }).indexOf(locationCriteria[i].id);

                                        if(index == -1){
                                            rebuildArr.push({id:locationCriteria[i].id,name:locationCriteria[i].name,count:0})
                                        }else{
                                            rebuildArr.push(criteria[key][count++]);
                                        }
                                    }

                                    criteria[key]=rebuildArr;
                                }
                            }
                        });
                        deferredTransformers.forEach(function (tr) {
                            criteria[tr.key] = tr.transformer();
                        });

                        loggerApiService.applicationEventStop();
                    });


            }

            // update URL with any model changes
            $scope.$watch("message", function (val, oldVal) {
                if (val == oldVal) return;
                updateLocationFromModel();
            }, true);
            $scope.$watch("checkboxGroupMessage", function (val, oldVal) {
                if (val == oldVal) return;
                updateLocationFromModel();
            }, true);

            // updates the location with values set in the condition manager
            // that in turn updates the condition manager with values set in the location
            // the reason for this pseudo-circular logic is that any change must go through the location
            // as it is possible to update the location manually and it still should work
            function updateLocationFromModel() {
                var searchParams = conditionManager.calculateSearchParams();
                $location.search(searchParams);
            }

            vm.submitForm = function (page) {
                loggerApiService.applicationEvent(3, "form1", "", "*","searchResult","",_uuid);
                loggerApiService.applicationEventAddEvent("clicked","Search_Button")
                loggerApiService.applicationEventAddEvent("location",$routeParams.locCode);
                loggerApiService.applicationEventStart();
                $scope.message['sort']='rlRunNo_a_yr_d_mk_a_md_a';

                var searchConditions = conditionManager.calculateSearchParams();

                if(parseInt(searchConditions['yr.l']) > parseInt(searchConditions['yr.u'])){
                    var yrLower = searchConditions['yr.l'];
                    var yrUpper= searchConditions['yr.u'];

                    searchConditions['yr.l']=yrUpper;
                    searchConditions['yr.u']=yrLower;
                }

                $location.path(page).search(searchConditions).hash([]);
            };

            function getJsonParams(json) {
                var params = json.replace(/[\"\[\]\{\}-]/g, "");
                params = params.replace(/[\:]/g, "=");
                params = params.replace(/[\,]/g, "&");
                return "?" + params.toString();
            }

            vm.clear = function (condName) {
                if (!condName) return;
                condName = [].concat(condName);
                condName.forEach(function (x) {
                    conditionManager.clearCondition(x);
                });
            };

            config.conditionalSelectors.forEach(function (sel) {
                $scope.$watch(function () {
                    return sel.dependencyCondition(conditionManager)
                }, function (val, oldVal) {
                    if (val == oldVal) return;
                    searchService.search($scope, function (searchContext) {
                        prepareForCountRetrieval(searchContext);
                        config.getApplicableValuesConfig(sel.cond).requestor(searchContext, conditionManager);
                    })
                        .then(function (searchResult) {
                            var conditionValues = searchResult.getApplicableConditionValues();
                            var transformedValues = config.getApplicableValuesConfig(sel.cond).transformer(conditionValues, conditionManager, criteria);
                            criteria[sel.cond] = transformedValues;

                            // if the parent selection changes then deselect any values that are not currently visible
                            var set = sel.map(transformedValues);
                            var selected = conditionManager.checkboxGroupMessage[sel.cond].refined();
                            var modified = false;
                            selected.forEach(function (option) {
                                if (!set[option]) conditionManager.checkboxGroupMessage[sel.cond].crude[option] = false;
                                modified = true;
                            });
                            if (modified) updateLocationFromModel();
                        });
                }, true);
            });

            function prepareForCountRetrieval(searchContext) {
                searchContext.resetConditions();
                searchContext.resetConditionEnumerations();
                config.defaultConditionsArr.forEach(function (cn) {
                    searchContext.getCondition(cn).setValue(conditionManager.getConditionValue(cn));
                });

                searchContext.getCondition('auch').setValue(["rl", "lb"]);
                searchContext.getCondition('pao').setValue(specificLocationSelected);
                searchContext.getCondition('sz').setValue(0);
                searchContext.setResponseScope(19);
            }


            vm.truncateStr = function (str, cnt, len) {
                if (!str) return str;
                var cnt_len = cnt ? cnt.length : 0;
                if (str.length + cnt_len > len + 3) return (str.slice(0, len - cnt_len) + "...");
                return str;
            };

            vm.refreshClear = function (condition) {
                vm.clear(condition);
                updateUrl();

            };

            //use to update the ng-model of search criteria boxes
            //$scope.message will be updated base on the criteriaName. example(when user select value from make,model or location criteriaName will be pass as parameter and use it to update $scope.message[criteriaName])
            //then assign the criteriaSelected value to $scope.message
            vm.selectedCriteria = function (criteriaSelected,criteriaName) {
                $scope.message[criteriaName]=criteriaSelected;
                vm.clear([criteriaName]);
            };

            // update current URL with parameters from search results
            function updateUrl(params) {
                if (!params) params = {};
                var search = conditionManager.calculateSearchParams(params.removedCondition);

                $location.search(search);
            }

            vm.isLocationClickable = function () {
                if ($routeParams.locCode === APP_CONFIG.DEFAULT_HOME) {
                    return true;
                } else {

                    angular.element('#selectLocationCriteriaId').css("background", "none");
                    return false;
                }
            };

            vm.emptyOrNull = function (item) {
                return !(item.count === null || item.count.trim().length === 0)
            }
        }
})();


// WEBPACK FOOTER //
// ./app/search/criteria/SearchCriteriaController.js